/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Contacts
 */
export interface Contacts {
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    phoneAdditional?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Contacts
     */
    dataBoxId?: string | null;
}

/**
 * Check if a given object implements the Contacts interface.
 */
export function instanceOfContacts(value: object): value is Contacts {
    return true;
}

export function ContactsFromJSON(json: any): Contacts {
    return ContactsFromJSONTyped(json, false);
}

export function ContactsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contacts {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'] == null ? undefined : json['phone'],
        'phoneAdditional': json['phoneAdditional'] == null ? undefined : json['phoneAdditional'],
        'email': json['email'] == null ? undefined : json['email'],
        'dataBoxId': json['dataBoxId'] == null ? undefined : json['dataBoxId'],
    };
}

export function ContactsToJSON(json: any): Contacts {
    return ContactsToJSONTyped(json, false);
}

export function ContactsToJSONTyped(value?: Contacts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'phoneAdditional': value['phoneAdditional'],
        'email': value['email'],
        'dataBoxId': value['dataBoxId'],
    };
}

